//------------------------------
//カテゴリーメニュー
//------------------------------
$(document).ready(function () {
  const $categoryMenu = $('.category_menu');
  if ($categoryMenu.length === 0) return;

  const $categoryArea = $('#categoryArea');

  function isMobile() {
    return window.innerWidth <= 980; 
  }

  // 初期表示制御
  if (!isMobile()) {
    $categoryArea.show();
  }
  
  $(window).on('resize', function () {
    if (!isMobile()) {
      $categoryArea.show();
    } else {
      $categoryArea.hide();
    }
  });
    
  $(document).on('click', '#categoryToggleBtn', function () {
    //カテゴリーメニューを表示 / 非表示
    $categoryArea.slideToggle(400);
    $categoryMenu.toggleClass('opened');
  });
}); 

//------------------------------
//フィルター機能
//------------------------------
$(document).ready(function () {
  const $filterArea = $('#filterArea');
  if ($filterArea.length === 0) return;
  
  const key = 'filterToggleOpen';
  const $obsTarget = document.querySelector('#CollectionProductGrid');

  // ===== 非同期処理監視 =====
  if ($obsTarget) {
    const observer = new MutationObserver(() => {
      // ===== 絞り込みで商品が動的に更新 =====
      const $filterAreaUpdate = $('#filterArea');
      const $filterToggleBtnUpdate = $('#filterToggleBtn');
      const $filterResultsAreaUpdate = $('.filtering__results-area');
      
      //初期状態をセット
      if (localStorage.getItem(key) === 'true') {
        //フィルターエリアを表示 / 非表示
        $filterAreaUpdate.addClass('opened');

        //「FILTER」ボタン/「絞り込みを閉じる」ボタン の表示変更
        $filterToggleBtnUpdate.addClass('opened');
        $filterResultsAreaUpdate.addClass('opened');
      }
    });
  
    observer.observe($obsTarget, { childList: true, subtree: true });
  }

  // ===== 「FILTER」ボタン =====
  $(document).on('click', '#filterToggleBtn', function () { 
    const $filterAreaUpdate = $('#filterArea');
    const $filterToggleBtnUpdate = $('#filterToggleBtn');
    const $filterResultsAreaUpdate = $('.filtering__results-area');

    //フィルターエリアを表示 / 非表示
    $filterAreaUpdate.toggleClass('opened');

    //「FILTER」ボタン/「絞り込みを閉じる」ボタン の表示変更
    $filterToggleBtnUpdate.addClass('opened');
    if($filterAreaUpdate.hasClass('opened')){
      $filterToggleBtnUpdate.addClass('opened');
      $filterResultsAreaUpdate.addClass('opened');
    }else{
      $filterToggleBtnUpdate.removeClass('opened');
      $filterResultsAreaUpdate.removeClass('opened');
    }

    //商品一覧のフェードが残ったままで非表示になるのを防ぐ
    $('#main-collection-product-grid').attr('data-aos', '');
    
    //フィルターの状態（OPEN/CLOSE）を保持
    localStorage.setItem(key, $filterAreaUpdate.hasClass('opened'));
  });

  // ===== 「閉じる」ボタン ※フィルターエリア内 =====
  $(document).on('click', '#filterCloseBtn', function () { 
    const $filterAreaUpdate = $('#filterArea');
    const $filterToggleBtnUpdate = $('#filterToggleBtn');
    const $filterResultsAreaUpdate = $('.filtering__results-area');

    //フィルターエリアを非表示
    $filterAreaUpdate.toggleClass('opened');

    //「FILTER」ボタン/「絞り込みを閉じる」ボタン の表示変更
    $filterToggleBtnUpdate.removeClass('opened');
    $filterResultsAreaUpdate.removeClass('opened');
   
    //商品一覧のフェードが残ったままで非表示になるのを防ぐ
    $('#main-collection-product-grid').attr('data-aos', '');
    
    //フィルターの状態（OPEN/CLOSE）を保持
    localStorage.setItem(key, $filterAreaUpdate.hasClass('opened'));
  });
});